import React from 'react';
import axios from 'axios';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import { isEmpty } from 'lodash';
import InfluenceQuestions from './influence-questions';
import {
    getComponentVisibility, addCompletedFormToAddressBookLocalStorage, getVerificationEndpoint, getUserAddressBooks, verifyUserInAddressBook, getUserDetailsFromCookie
} from '../helpers/toch-helpers';
import userService from '../../../../general/js/user/user-service';
import { TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME } from '../../../../general/js/user/constants';

class InfluenceSurveyLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSubmitAttempted: false,
            isDataSent: false,
            fieldsErrors: {},
            answers: [],
            formHasErrors: false,
            addressBooks: null
        };

        this.onAnswerChange = this.onAnswerChange.bind(this);
        this.handleComponentVisibilityApiCall = this.handleComponentVisibilityApiCall.bind(this);
    }

    componentDidMount() {
        this.checkCompetitionStatus();
    }

    checkCompetitionStatus() {
        const { verificationEndpoint, dotmailerBookId } = this.props.options;
        const userAddressBooks = getUserAddressBooks();

        if (!isEmpty(verificationEndpoint) && userAddressBooks === null) this.handleComponentVisibilityApiCall();

        const userInAddressBook = verifyUserInAddressBook(userAddressBooks, dotmailerBookId);

        if (userInAddressBook) {
            this.setState({ isDataSent: true });
        }
    }

    handleComponentVisibilityApiCall() {
        const endpoint = getVerificationEndpoint(this.props.options);

        axios.post(endpoint).then((response) => {
            if (response.data !== null && response.data !== undefined && response.data !== '') {
                userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(response.data));
                this.setState({ addressBooks: response.data });
            }
        }).catch(() => {
            this.setState({ competitionsList: null });
        });
    }

    onSubmit = (e) => {
        e.preventDefault();

        const { dotmailerBookId, dotmailerBookName } = this.props.options;
        const { answers } = this.state;
        const updatedUserAddressBooks = addCompletedFormToAddressBookLocalStorage(dotmailerBookId, dotmailerBookName);
        const userDetails = getUserDetailsFromCookie();

        if (!this.state.isDataSent) {
            this.setState({ isSubmitAttempted: true });
            if (answers !== undefined) {
                const data = {
                    emailAddress: userDetails.email,
                    firstName: userDetails.firstName,
                    lastName: userDetails.lastName,
                    addressBookId: dotmailerBookId,
                    addressBookName: dotmailerBookName,
                    answers: this.state.answers,
                };

                axios.post(this.props.options.endpoint, data).then(() => {
                    userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(updatedUserAddressBooks));
                    this.setState({ isDataSent: true, addressBooks: updatedUserAddressBooks });
                }).catch((error) => {
                    this.setState({ formHasErrors: true });
                    console.error(error);
                });
            }
        }
    }

    onAnswerChange = (value) => {
        this.setState({ answers: value });
    }

    render() {
        const {
            questions,
            title,
            freeTextMessage,
            background,
            componentVisibility,
            isMasterCardComponent,
            masterCardLogo,
            masterCardText,
            surveyCompletedMessage,
            surveyHasErrorsMessage,
            ctaLink,
            submitButtonText,
            dotmailerBookId
        } = this.props.options;
        const { isDataSent, formHasErrors, addressBooks } = this.state;
        const isVisible = getComponentVisibility(componentVisibility);
        const isMastercard = isMasterCardComponent.toLowerCase() === 'true';
        const isInAddressBooks = addressBooks !== null ? verifyUserInAddressBook(JSON.stringify(addressBooks), dotmailerBookId) : null;
        const disable = isInAddressBooks !== null ? isInAddressBooks : isDataSent;

        return (
            isVisible &&
            <div className="influence-survey__wrap">
                <div className="influence-survey__media">
                    <div className="influence-survey__media--wrapper">
                        <SitecoreImageField img={background} className='influence-survey__media--backgroundImage' />
                    </div>
                </div>
                <div className="influence-survey__content">
                    {
                        isMastercard &&
                        <div className='mastercard-branding'>
                            <div className='mastercard-branding--title'>{masterCardText}</div>
                            <SitecoreImageField img={masterCardLogo} className='mastercard-branding--logo' />
                        </div>
                    }
                    <div className="influence-survey__heading">
                        <h2 className="influence-survey__title">{title}</h2>
                    </div>
                    <form className="influence-survey__form" onSubmit={this.onSubmit}>
                        <div className={`toch-survey ${disable ? 'is-disabled' : ''}`}>
                            <div className="toch-survey__wrap">
                                <div className="toch-survey__title">
                                </div>
                                <div className="toch-survey__content">
                                    <InfluenceQuestions
                                        questions={questions}
                                        freeTextMessage={freeTextMessage}
                                        onAnswerChange={this.onAnswerChange} />
                                </div>
                            </div>
                        </div>
                        {
                            !isDataSent &&
                            <div className="toch-survey__submit-button">
                                <button
                                    type="submit"
                                    className="button button--super"
                                >
                                    <span className="button-content button-content--icon">
                                        <span>{submitButtonText}</span>
                                        <svg
                                            className="icon button__arrow-right"
                                            width="14" height="12"
                                            focusable="false">
                                            <use xlinkHref="#icon-arrow-right">
                                            </use>
                                        </svg>
                                    </span>
                                </button>
                                {
                                    formHasErrors &&
                                    <div className="toch-survey__message">{surveyHasErrorsMessage}</div>
                                }
                            </div>
                        }
                        {
                            disable &&
                            <div className="toch-survey__submit-button">
                                <SitecoreLinkField className="button button--primary" link={ctaLink} />
                                <div className="toch-survey__message">{surveyCompletedMessage}</div>
                            </div>
                        }
                    </form>
                    {
                        isMastercard &&
                        <div className='mastercard-branding to-bottom'>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default InfluenceSurveyLayout;
